import { Box, Button } from '@chakra-ui/react';
import { ChangeEvent, useRef } from 'react';

type FileUploadProps = {
    onCancel: () => void;
    onSelectFile: (file?: File) => void;
    file?: File;
    handleSubmit: () => void;
};

export const FileUpload = ({
    onSelectFile,
    file,
    handleSubmit,
}: FileUploadProps) => {
    const inputFileRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const uploadedFile = event.target.files?.[0];
        if (uploadedFile) {
            onSelectFile(uploadedFile);
        }
    };

    const handleChooseFileClick = () => {
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    };

    return (
        <Box>
            {!file ? (
                <>
                    <input
                        accept=".xlsx,.xls"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={handleFileChange}
                        ref={inputFileRef}
                    />
                    <Button
                        variant="contained"
                        bg={'primary.500'}
                        color={'white'}
                        _hover={{ bg: 'primary.600' }}
                        onClick={handleChooseFileClick}
                    >
                        Choose File
                    </Button>
                </>
            ) : (
                <>
                    <Button
                        variant="contained"
                        bg={'success.500'}
                        color={'white'}
                        _hover={{ bg: 'success.600' }}
                        onClick={handleSubmit}
                        disabled={!file}
                    >
                        Upload
                    </Button>
                    <div>{file.name}</div>
                </>
            )}
        </Box>
    );
};
